export default __webpack_public_path__ + "static/media/UKCB-PassengerApp-Logo.5f868503.png";